import { TourSummary } from "@/types/dto/pdp/pdp-tour-summary";

 const tourSummaryFactory = (
  solrData: any = {},
  contentfulData: any = {}
): TourSummary => {
  const accommodationCount = solrData?.accommodationCount ?? 0;
  const totalMeals = solrData?.totalMeals ?? 0;
  const choiceOnTour = solrData?.choiceOnTourCount ?? 0;

  const included = [
    ...(accommodationCount > 0 ? [accommodationCount] : []),
    ...(totalMeals > 0 ? [totalMeals] : []),
    ...(choiceOnTour > 0 ? [choiceOnTour] : [])
  ];

  return {
    summary: solrData?.summary ?? "",
    highlights: solrData?.highlights ?? [],
    included,
    mustSee: solrData?.mustSee ?? [],
    cultural: solrData?.cultural ?? [],
    culinary: solrData?.culinary ?? [],
    accommodationCount,
    totalMeals,
    choiceOnTour,
    activityLevelDescription: solrData?.activityLevelDescription ?? "",
    physicalRequirement: contentfulData?.physicalRequirement ?? "",
    groupSize: solrData?.groupSize ?? 0,
    travelStyles: solrData?.travelStyles ?? [],
    activityLevel: solrData.activityLevel ?? 0,
    totalBreakfasts: solrData?.totalBreakfasts ?? "",
    totalDinners: solrData?.totalDinners ?? "",
    totalLunches: solrData?.totalLunches ?? "",    
    excursions: solrData?.excursions ?? undefined,
    postExtension: solrData?.postExtension ?? undefined,
    preExtension: solrData?.preExtension ?? undefined,
    preNightItem: solrData?.preNightItem ?? undefined,
    postNightItem: solrData?.postNightItem ?? undefined
  };
};

export default tourSummaryFactory;